import { render, staticRenderFns } from "./MainLedgerDetailBankStatementCRUD.vue?vue&type=template&id=1a1b123e"
import script from "./MainLedgerDetailBankStatementCRUD.vue?vue&type=script&lang=js"
export * from "./MainLedgerDetailBankStatementCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports